export default [
  { US: 'USA' },
  { AD: 'Andorra' },
  { AI: 'Anguilla' },
  { AR: 'Argentina' },
  { AT: 'Austria' },
  { AU: 'Australia' },
  { AZ: 'Azerbaijan' },
  { BS: 'Bahamas' },
  { BH: 'Bahrain' },
  { BB: 'Barbados' },
  { BE: 'Belgium' },
  { BM: 'Bermuda' },
  { BR: 'Brazil' },
  { BG: 'Bulgaria' },
  { CA: 'Canada' },
  { CL: 'Chile' },
  { CN: 'China' },
  { CO: 'Colombia' },
  { CR: 'Costa Rica' },
  { HR: 'Croatia' },
  { CY: 'Cyprus' },
  { CZ: 'Czech Republic' },
  { DK: 'Denmark' },
  { DO: 'Dominican Republic' },
  { EC: 'Ecuador' },
  { EE: 'Estonia)' },
  { FO: 'Faroe Islands)' },
  { FI: 'Finland' },
  { FR: 'France' },
  { GE: 'Georgia' },
  { DE: 'Germany' },
  { GH: 'Ghana' },
  { GI: 'Gibraltar' },
  { GB: 'Great Britain' },
  { GR: 'Greece' },
  { HK: 'Hong Kong' },
  { HU: 'Hungary' },
  { IS: 'Iceland' },
  { IN: 'India' },
  { IE: 'Ireland' },
  { IL: 'Israel' },
  { IT: 'Italy' },
  { JM: 'Jamaica' },
  { JP: 'Japan' },
  { KR: 'Republic of Korea' },
  { LV: 'Latvia' },
  { LB: 'Lebanon' },
  { LT: 'Lithuania' },
  { LU: 'Luxembourg' },
  { MY: 'Malaysia' },
  { MT: 'Malta' },
  { MX: 'Mexico' },
  { MC: 'Monaco' },
  { ME: 'Montenegro' },
  { MA: 'Morocco' },
  { NL: 'Netherlands' },
  { AN: 'Netherlands Antilles' },
  { NZ: 'New Zealand' },
  { ND: 'Northern Ireland' },
  { NO: 'Norway' },
  { PE: 'Peru' },
  { PL: 'Poland' },
  { PT: 'Portugal' },
  { RO: 'Romania' },
  { RU: 'Russia' },
  { LC: 'Saint Lucia' },
  { SA: 'Saudi Arabia' },
  { RS: 'Serbia' },
  { SG: 'Singapore' },
  { SK: 'Slovakia' },
  { SI: 'Slovenia' },
  { ZA: 'South Africa' },
  { ES: 'Spain' },
  { SE: 'Sweden' },
  { CH: 'Switzerland' },
  { TW: 'Taiwan' },
  { TH: 'Thailand' },
  { TT: 'Trinidad and Tobago' },
  { TR: 'Turkey' },
  { UA: 'Ukraine' },
  { AE: 'UAE' },
  { UY: 'Uruguay' },
  { VE: 'Venezuela' },
];
